import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

/**
 * Sits beside the "High density?" warning on the weight field.
 *
 * `variant="warning"` rather than the `error` its siblings use: this one never
 * blocks a booking, and the orange mark says so before the customer opens it.
 */
export function LineItemsHighDensityQuestionBubble() {
  return (
    <Tooltip
      variant="warning"
      content={
        <Stack gap={2}>
          <T weight="bold">High density</T>
          <T size="xs" color="secondary">
            The measurements and weight you entered describe freight that would
            be extremely heavy for its size. Please double-check both, and make
            sure each value is in the units shown on the field.
          </T>
        </Stack>
      }
    />
  );
}
